import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {isAllRooms, RoomsFilter} from "../constants/rcn_rooms_filter";
import {PRICES_ADDRESS_ANALYTICS_LOCATION} from "./prices_city_analytics";

export const trackPricesAddressRoomsFilterApplied = (rooms: RoomsFilter) => {
    trackAmplitudeEvent("listing_filters_applied", {
        filter_trigger: "manual",
        location: PRICES_ADDRESS_ANALYTICS_LOCATION,
        // Same format as the listing filters ("2"); the all-rooms aggregate is no rooms filter at all.
        rooms: isAllRooms(rooms) ? null : String(rooms)
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {isAllRooms, RoomsFilter} from "../constants/rcn_rooms_filter";
import {PRICES_ADDRESS_ANALYTICS_LOCATION} from "./prices_city_analytics";

export const trackPricesAddressRoomsFilterApplied = (rooms: RoomsFilter) => {
    trackAmplitudeEvent("listing_filters_applied", {
        filter_trigger: "manual",
        location: PRICES_ADDRESS_ANALYTICS_LOCATION,
        // Same format as the listing filters ("2"); the all-rooms aggregate is no rooms filter at all.
        rooms: isAllRooms(rooms) ? null : String(rooms)
    });
};
